<app-header />

<!-- Main content -->
<main class="main-content">
  <router-outlet />
</main>